export default "__VITE_ASSET__UU0uMXdt__"